import request from '@/utils/request'

export const getLmTj_web = function(lotteryCode, query) {
  return request({
    url: `/v1/cp168/apis/recommend/liangMians?cpCode=${lotteryCode}`,
    method: 'get',
    params: query
  })
}
